<template>
  <div class="login-warp">
    <div class="lang-wrap" @click="isLangView = true">
      <span>{{ lang }}</span>
    </div>
    <div class="logo">
      <img src="../../assets/imgs/img_logo.png" alt="" />
    </div>
    <div class="wa-card">
      <div class="wa-card-tag">
        <svg class="wa-star" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 2l2.9 6.26 6.6.72-4.9 4.55 1.35 6.47L12 16.77 6.05 20l1.35-6.47-4.9-4.55 6.6-.72L12 2z"
          />
        </svg>
        <span class="wa-tag-bold">{{ i18n.whatsapp_recommended }}</span>
        <span class="wa-tag-dot">·</span>
        <span class="wa-tag-sub">{{ i18n.whatsapp_fastest_easiest }}</span>
      </div>
      <div class="btn wa-btn" @click="goWhatsapp">
        <svg class="wa-logo" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
          />
        </svg>
        {{ i18n.continue_with_whatsapp }}
      </div>
      <div class="wa-card-note">
        <span class="wa-check">✓</span>
        <span>{{ i18n.whatsapp_no_sms }}</span>
      </div>
    </div>
    <template v-if="smsLogin">
      <div class="sms-divider">
        <span>{{ i18n.or_use_sms }}</span>
      </div>
      <div class="login-row">
        <div class="area" @click="isAreaView = true">
          <span>+{{ areaCode }}</span>
          <div class="area-down"></div>
        </div>
        <input type="number" v-model="phone" :placeholder="i18n.phone_number" />
      </div>
      <div class="login-row">
        <input type="number" v-model="code" :placeholder="i18n.captcha_code" />
        <div class="login-code" @click="onCaptcha">
          <img :src="captchaUrl" />
        </div>
      </div>
    </template>
    <div class="login-info">
      <span
        >{{ i18n.agree }}
        <span class="readme" @click="onReadMe">{{ i18n.readme }}</span>
      </span>
    </div>
    <div v-if="smsLogin" class="btn" @click="onSendCode">{{ i18n.login }}</div>
    <div class="login-foot">
      <!-- <div class="login-foot-tips">
        <span>{{ i18n.sign_in_with }}</span>
      </div> -->
      <div class="login-foot-imgs">
        <!-- <login-facebook @success="loadUser">
          <img src="../../assets/imgs/icon_facebook.png" alt=""/>
        </login-facebook> -->
        <!-- <img src="../../assets/imgs/icon_google.png" alt=""> -->
        <!-- <login-google @success="loadUser">
          <div id="buttonDiv"></div>
        </login-google> -->
      </div>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <select-lang v-model="isLangView"></select-lang>
    <login-code
      v-if="isLoginCode"
      @submit="onLogin"
      @again="onBack"
      @back="onBack"
    ></login-code>
  </div>
</template>

<script>
import { SelectArea, SelectLang } from "../../components/select"
import { generateUUID } from "../../utils/index"
import { baseURL } from "../../utils/http"
import { USER_CAPTCHA, LOGIN_CODE, SEND_CODE } from "../../apis/user"
import { LoginCode, LoginGoogle } from "../../components/login"
import UserAuth from "../../mixins/user_auth"
import { mapState } from "vuex"
import AreaCodeDate from "@/utils/area_code.js"
export default {
  components: {
    SelectArea,
    SelectLang,
    LoginCode
    // LoginFacebook,
    // LoginGoogle
  },
  mixins: [UserAuth],
  computed: {
    ...mapState(["user", "browser", "lang"]),
    i18n() {
      return this.$t("login")
    },
    // 短信验证码登录开关:.env配置VUE_APP_SMS_LOGIN=false关闭,默认开启
    smsLogin() {
      return process.env.VUE_APP_SMS_LOGIN !== "false"
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        // 带机柜qrcode的扫码租借场景,登录后直接进套餐选择页(同游客模式体验)
        if (this.qrcode) {
          this.$router.push("/selectPakage?cabinetshow=true")
        } else {
          this.$router.push("/")
        }
      }
    }
  },
  data() {
    return {
      isAreaView: false,
      isLangView: false,
      areaCode: "974",
      phone: "",
      code: "",
      captchaUrl: "",
      uuid: "",
      isLoginCode: false
    }
  },
  methods: {
    onReadMe() {
      const VUE_APP_PACT = `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`
      window.open(VUE_APP_PACT)
    },
    onSelct(val) {
      this.areaCode = val
    },
    onCaptcha() {
      this.code = ""
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    onLogin(code) {
      this.$loading(true)
      const _query = {
        mobile: this.areaCode + this.phone,
        verifyCode: code,
        areaCode: this.areaCode,
        registAndLoginType: 1,
        isAutoFund: 0 // 是否微信自动退款：0：自动退款 1：手动提现
      }
      this.$post(
        LOGIN_CODE,
        _query,
        (res) => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit("token", res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (err) => {
          console.log(err)
          this.$loading(false)
        }
      )
    },
    onSendCode() {
      this.$loading(true)
      const _query = {
        mobile: this.areaCode + this.phone,
        uuid: this.uuid,
        code: this.code,
        useDebug: false
      }
      this.$post(
        SEND_CODE,
        _query,
        (res) => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        }
      )
    },
    onBack() {
      this.isLoginCode = false
      this.onCaptcha()
    },
    goWhatsapp() {
      // 桌面端无法直接唤起WhatsApp,走等待页扫二维码
      if (!this.isMobile) {
        this.$router.push("/login_whatsapp")
        return
      }
      // 移动端:直接唤起WhatsApp,留在本页轮询登录结果
      this.createSession((res) => {
        window.location.href = res.waLink
      })
    },
    // 会话过期(在WhatsApp里停留过久/未批准):转去等待页重新发起
    onWaSessionExpired() {
      this.$router.push("/login_whatsapp")
    }
  },
  created() {
    if (this.browser === "wechat") {
      this.$router.push("/login_wechat")
    } else if (this.browser === "alipay") {
      this.$router.push("/login_alipay")
    }
    // const langCode = window.navigator.language.substring(3)
    // let temp = AreaCodeDate.find(item => item.code === langCode)
    // if (temp && temp.value) {
    //   this.areaCode = temp.value
    // }
  },
  mounted() {
    // 图形验证码只服务短信登录,关闭后不再请求
    if (this.smsLogin) {
      this.onCaptcha()
    }
  }
}
</script>

<style lang="less">
.login-warp {
  height: 100vh;
  background-color: #fff;

  .lang-wrap {
    position: absolute;
    top: 54px;
    right: 54px;
    padding: 8px 16px;
    border: 2px solid #0f7ed7;
    border-radius: 8px;
    font-size: 24px;
    color: #0f7ed7;
  }

  .logo {
    padding: 100px 0 40px 0;

    img {
      display: block;
      margin: 0 auto;
      width: 320px;
    }
  }

  .login-row {
    margin: 36px 96px;
    height: 92px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // border-bottom: 4px solid #000;
    border: 4px solid #0f7ed7;
    border-radius: 16px;

    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }

    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: black transparent transparent;
    }

    .login-code {
      width: 180px;
      height: 66px;
      margin-right: 8px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );

      img {
        width: 180px;
        height: 66px;
      }
    }
  }

  .btn {
    margin: 60px 96px 0;
    border-radius: 16px;
  }

  .wa-card {
    margin: 0 96px;
    padding: 20px;
    background-color: #f0faf3;
    border: 2px solid #b9e8c9;
    border-radius: 20px;

    .wa-card-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      margin-bottom: 16px;

      .wa-star {
        width: 24px;
        height: 24px;
        fill: #16a34a;
        margin-right: 8px;
      }

      .wa-tag-bold {
        color: #15803d;
        font-weight: 600;
      }

      .wa-tag-dot {
        color: #9ca3af;
        margin: 0 10px;
      }

      .wa-tag-sub {
        color: #6b7280;
      }
    }

    .wa-btn {
      margin: 0;
      height: 76px;
      background-color: #25d366;
      color: #fff;
      font-weight: 600;
      font-size: 26px;
      border-radius: 14px;
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.35);

      .wa-logo {
        width: 36px;
        height: 36px;
        fill: #fff;
        margin-right: 12px;
      }
    }

    .wa-card-note {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
      font-size: 22px;
      color: #15803d;

      .wa-check {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 28px;
        margin-right: 8px;
        border: 2px solid #16a34a;
        border-radius: 50%;
        color: #16a34a;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  .sms-divider {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 96px 0;
    position: relative;

    span {
      z-index: 1;
      background: #fff;
      padding: 0 20px;
      font-size: 24px;
      color: #9ca3af;
    }

    &::after {
      position: absolute;
      content: " ";
      height: 1px;
      width: 100%;
      background-color: #e5e7eb;
    }
  }

  .login-foot {
    position: fixed;
    left: 96px;
    right: 96px;
    bottom: 48px;

    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      span {
        z-index: 999;
        background: #fff;
        padding: 28px;
        color: #0f7ed7;
      }

      &::after {
        position: absolute;
        content: " ";
        height: 1px;
        width: 100%;
        background-color: #29cdf0;
        z-index: 99;
      }
    }

    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .login-info {
    font-size: 24px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 33px;
    display: flex;
    justify-content: flex-start;
    padding: 0 96px;
  }

  .login-info .readme {
    font-weight: 500;
    color: rgba(52, 125, 255, 1);
    margin-left: 10px;
    display: inline;
  }
}
</style>
